import { CircularProgress, Dialog } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { getSipCancelReasons } from '../../../../redux-store/actions/commercialTransactions';
import { RootStateType } from '../../../../redux-store/reducers';

const SIPButton = ({
    text,
    right = 0,
    apiCalled,
    loading,
    handleSubmit,
}: {
    text: string;
    right?: number;
    apiCalled: boolean;
    loading: boolean;
    handleSubmit: any;
}) => {
    return (
        <>
            <SubmitButtonWithLoader
                className="customBtn cancelBtn"
                data-testid="sip-button"
                disabled={apiCalled}
                loading={loading}
                style={{
                    position: 'absolute',
                    bottom: 0,
                    fontSize: 15,
                    right: right,
                    width: '90px',
                    height: '35px',
                }}
                label={text}
                onClick={handleSubmit}
            />
        </>
    );
};

export const SipReasonsLoadingDialog = ( { loading } : { loading : boolean } ) => {
    return (
        <Dialog 
            maxWidth={'sm'}
            open={loading}
            aria-labelledby="enable-fingerprint-modal"
        >
            <div className="enable-fingerprint-modal">
                <CircularProgress />
                <p style={{ marginTop: '12px' }}>{'Fetching SIP Cancel Reasons...'}</p>
            </div>
        </Dialog>
    );
}

export const SIPCancelDialog = ({
    showDialog,
    setShowDialog,
    setButtonClicked,
    setShowReasonDialog,
    callPauseApi,
    callCancelApi,
    disabled,
}: {
    showDialog: boolean;
    setShowDialog: any;
    callPauseApi: () => Promise<void>;
    callCancelApi: () => Promise<void>;
    setShowReasonDialog: any;
    setButtonClicked: any;
    disabled: boolean;
}) => {
    const dispatch = useDispatch();
    return (
        <>
            <Dialog maxWidth={'sm'} open={showDialog} aria-labelledby="transmission-main-modal">
                <div className="note-modals transmission-main-modal">
                    <h3>SIP Cancel</h3>
                    <p>
                        Dear Investor, Are you sure you want to cancel SIP? You can choose to pause
                        instead.
                    </p>
                    <div className="note-modals-btns">
                        <SubmitButtonWithLoader
                            className="customBtn"
                            onClick={async () => {
                                setButtonClicked('CSIP');
                                setShowDialog(false);
                                await callCancelApi();
                            }}
                            disabled={disabled}
                            label="Proceed with cancel"
                        />
                        <SubmitButtonWithLoader
                            className="customBtn"
                            onClick={async () => {
                                setButtonClicked('PSIP');
                                await callPauseApi();
                            }}
                            disabled={disabled}
                            label="Pause SIP"
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
export default SIPButton;
